import { render } from "./pdfPreview.vue?vue&type=template&id=20ac7544&scoped=true"
import script from "./pdfPreview.vue?vue&type=script&lang=js"
export * from "./pdfPreview.vue?vue&type=script&lang=js"

import "./pdfPreview.vue?vue&type=style&index=0&id=20ac7544&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ac7544"]])

export default __exports__